import { render, staticRenderFns } from "./acquista-un-buono.vue?vue&type=template&id=69e0aa6f"
import script from "./acquista-un-buono.vue?vue&type=script&lang=js"
export * from "./acquista-un-buono.vue?vue&type=script&lang=js"
import style0 from "./acquista-un-buono.vue?vue&type=style&index=0&id=69e0aa6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports